import React from 'react';
import { IconX } from '@tabler/icons-react';
import './SidePanel.css';

interface SidePanelProps {
  title: string;
  /** 'leave' shows the amber type chip next to the title. */
  type?: 'appointment' | 'leave';
  submitLabel: string;
  isValid: boolean;
  onClose: () => void;
  onSubmit: () => void;
  /** Optional left-aligned destructive action (e.g. delete leave when editing). */
  onDelete?: () => void;
  deleteLabel?: string;
  deleteDisabled?: boolean;
  children: React.ReactNode;
}

/**
 * Shared right-aligned panel shell for the calendar's Schedule Appointment and
 * Add Leave flows. Header (title + optional type chip + close) over a scrolling
 * body (the form fields) over a footer (cancel + primary, plus an optional
 * destructive action).
 */
export const SidePanel: React.FC<SidePanelProps> = ({
  title,
  type = 'appointment',
  submitLabel,
  isValid,
  onClose,
  onSubmit,
  onDelete,
  deleteLabel = 'Delete',
  deleteDisabled = false,
  children,
}) => (
  <div className="side-panel">
    <div className="side-panel__header">
      <span className="side-panel__title">
        {title}
        {type === 'leave' && (
          <span className="side-panel__type-chip side-panel__type-chip--leave">Leave</span>
        )}
      </span>
      <button type="button" className="side-panel__close" onClick={onClose} aria-label="Close">
        <IconX size={16} stroke={1.5} />
      </button>
    </div>

    <div className="side-panel__body">{children}</div>

    <div className="side-panel__footer">
      {onDelete && (
        <button
          type="button"
          className="side-panel__btn-delete"
          onClick={onDelete}
          disabled={deleteDisabled}
        >
          {deleteLabel}
        </button>
      )}
      <button type="button" className="side-panel__btn-cancel" onClick={onClose}>
        Cancel
      </button>
      <button
        type="button"
        className="side-panel__btn-primary"
        onClick={onSubmit}
        disabled={!isValid}
      >
        {submitLabel}
      </button>
    </div>
  </div>
);
